module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_c('i', [_vm._v("And She spread it before me and it was written")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Within and without this roll of a book")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("A roll of a book was therein, and there was written lamentations, mourning and woe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Moreover,” She said unto me, “Son of Man, eat that thou findest; eat this roll and go speak unto the House of Israel.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("So I opened my mouth and She caused me to eat that roll. And She said unto me, “Son of Man, cause thy belly to eat. Fill thy bowels with this roll that I give thee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Then did I eat it; and it was in my mouth as honey for sweetness")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13599ae8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Front03.vue
// module id = 84
// module chunks = 0